module.exports = __webpack_public_path__ + "media/components/blocks/ProUpsell/logo_pro-a76f328580f85964fd58b78b1e27849d.png";